<template>
  <Block :badge-class="statusClassBg" :emoji="statusEmoji">
    <template #title>
      <h3 class="text-xl font-bold tracking-tight text-black">
        {{ current }} / {{ $t("roadmap.sales", target) }} ce mois
        <span class="text-xs text-gray-600">({{ formatPercentage(progression) }})</span>
        <span v-if="leadsWaiting > 0" class="text-sm text-gray-600 font-normal ml-1">
          · +{{ $t("roadmap.sales", leadsWaiting) }} SEPA en attente
        </span>
      </h3>
    </template>

    <template #subtitle>
      <h3 class="text-lg font-medium tracking-tight text-gray-600">
        {{ $t("roadmap.sales", projection) }} prévues d'ici la fin du mois
        <span class="text-xs text-gray-600">({{ formatPercentage(projectionProgression) }})</span>
      </h3>
    </template>

    <template #actions>
      <div class="hidden md:block px-3 py-1 rounded-full text-sm font-semibold shadow-md" :class="statusClass">
        {{ statusLabel }}
      </div>
    </template>

    <div class="px-6 pb-4">
      <ProgressionBar :value="current" :max="target" :color="progressColor" size="h-4" />
    </div>
  </Block>
</template>

<script>
import { ProgressionBar, Block, formatPercentage } from "@estaly/ui";
import { mapGetters } from "vuex";
import { boosterThresholds, getNextTier, getReachedTier, multiplierPercentage } from "@/utils/booster";

export default {
  components: {
    Block,
    ProgressionBar,
  },
  data() {
    return {
      boosterThresholds,
    };
  },
  props: {
    current: {
      type: Number,
      required: true,
    },
    target: {
      type: Number,
      required: true,
    },
    projection: {
      type: Number,
      required: true,
    },
    leadsWaiting: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    ...mapGetters("store", ["retributionsBoostEnabled"]),

    reachedTier() {
      if (!this.retributionsBoostEnabled()) return null;
      return getReachedTier(this.current, this.boosterThresholds);
    },
    nextTier() {
      if (!this.retributionsBoostEnabled()) return null;
      return getNextTier(this.current, this.boosterThresholds);
    },
    progression() {
      return this.target > 0 ? this.current / this.target : 0;
    },
    projectionProgression() {
      return this.target > 0 ? this.projection / this.target : 0;
    },
    statusLabel() {
      if (this.projectionProgression < 0.8) return "En retard";
      if (this.projectionProgression <= 1) return "Dans les temps";
      return "En avance";
    },
    statusClass() {
      if (this.projectionProgression < 0.8) return "bg-red-50 text-red-700 border border-red-50";
      if (this.projectionProgression <= 1) return "bg-blue-50 text-blue-700 border border-blue-50";
      return "bg-green-50 text-green-700";
    },
    statusClassBg() {
      if (this.projectionProgression < 0.8) return "bg-red-50";
      if (this.projectionProgression <= 1) return "bg-blue-50";
      return "bg-green-50";
    },
    statusEmoji() {
      if (this.projectionProgression < 0.8) return "🕓";
      if (this.projectionProgression <= 1) return "📊";
      return "🚀";
    },
    progressColor() {
      if (this.projectionProgression < 0.8) return "#EF4444";
      if (this.projectionProgression <= 1) return "#3B82F6";
      return "#10B981";
    },
  },
  methods: {
    formatPercentage,
    multiplierPercentage,
  },
};
</script>
